import type { SiteWorkEstimate } from "../../score/computeSiteWorkEstimate";

/**
 * Imperative glue that lets the handset drawer (ViewerRailsDrawer) render the
 * Site Work card. The estimate getter lives in `bootViewer`'s closures and is
 * only handed to `mountSiteWorkCard`, so the mount registers it here — same
 * pattern as `inspectorDrawerControlsBridge`.
 */
export interface SiteWorkDrawerSource {
  getEstimate: () => SiteWorkEstimate;
  /** "Print contractor summary (PDF)" handler; button hidden when undefined. */
  onPrintHandoff?: () => void;
}

/** Valid placeholder so drawer drill-ins never crash before the card mounts. */
const emptyEstimate: SiteWorkEstimate = {
  earthworkPerStructure: [],
  drivewayInstall: null,
  siteFacts: {
    soilDrainageClass: null,
    soilHydric: null,
    bestBuildableAvgSlopePercent: null,
    floodZoneCode: null,
    wetlandsCoverageFraction: null,
    drainageSinksInsideParcel: 0
  },
  regionalMultiplier: {
    value: 1,
    basis: "national median (regional data not loaded yet)"
  }
};

const noopSource: SiteWorkDrawerSource = {
  getEstimate: () => emptyEstimate
};

let active: SiteWorkDrawerSource | null = null;

export function registerSiteWorkDrawerSource(
  next: SiteWorkDrawerSource | null
): void {
  active = next;
}

export function getSiteWorkDrawerSource(): SiteWorkDrawerSource {
  return active ?? noopSource;
}
